import axios, { AxiosError } from 'axios'
import { ActionWithPayload, AppDispatch, RootState } from '../store'

const PROMO_CODE_VALIDATE_REQUEST = 'PROMO_CODE_VALIDATE_REQUEST'
const PROMO_CODE_VALIDATE_SUCCESS = 'PROMO_CODE_VALIDATE_SUCCESS'
const PROMO_CODE_VALIDATE_ERROR = 'PROMO_CODE_VALIDATE_ERROR'
export const PROMO_CODE_VALIDATE_RESET = 'PROMO_CODE_VALIDATE_RESET'

interface PromoCodeValidateRequestAction {
  type: typeof PROMO_CODE_VALIDATE_REQUEST
}

interface PromoCodeValidateSuccessAction {
  type: typeof PROMO_CODE_VALIDATE_SUCCESS
  payload: boolean
}

interface PromoCodeValidateErrorAction {
  type: typeof PROMO_CODE_VALIDATE_ERROR
  payload: string
}

type PromoCodeValidateActionTypes =
  | PromoCodeValidateRequestAction
  | PromoCodeValidateSuccessAction
  | PromoCodeValidateErrorAction

export const validatePromoCode =
  (name: string) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      dispatch({
        type: PROMO_CODE_VALIDATE_REQUEST,
      })

      const {
        userLogin: { userInfo },
      } = getState()
      const token = (userInfo as User).token

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }

      const { data } = await axios.post(
        `/api/promoCodes/validate`,
        { name },
        config
      )

      dispatch({
        type: PROMO_CODE_VALIDATE_SUCCESS,
        payload: data,
      })
    } catch (err: unknown) {
      let errorMessage = 'An unexpected error occurred'

      if (axios.isAxiosError(err)) {
        const error = err as AxiosError

        if (error.response && error.response.data) {
          errorMessage = (error.response.data as { message: string }).message
        } else {
          errorMessage = error.message
        }
      } else if (err instanceof Error) {
        // This will be true for any instance of Error
        errorMessage = err.message
      }

      dispatch({
        type: PROMO_CODE_VALIDATE_ERROR,
        payload: errorMessage,
      })
    }
  }

interface InitialState {
  code: PromoCode | undefined
  error: string
  loading: boolean
  success: boolean
}

const initialState: InitialState = {
  error: '',
  loading: false,
  success: false,
  code: undefined,
}

export const validatePromoCodeReducer = (
  state = initialState,
  action: ActionWithPayload<PromoCodeValidateActionTypes>
) => {
  switch (action.type) {
    case PROMO_CODE_VALIDATE_REQUEST:
      return {
        ...state,
        error: '',
        loading: true,
        success: false,
      }
    case PROMO_CODE_VALIDATE_SUCCESS:
      return {
        ...state,
        error: '',
        success: true,
        loading: false,
        code: action.payload,
      }
    case PROMO_CODE_VALIDATE_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        success: false,
      }
    case PROMO_CODE_VALIDATE_RESET:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
